import { TFunction } from 'core/i18n/i18n';
import type { PocInputValidity } from 'commons/types';
import { ExtendedValidationMessages } from 'commons/components';
import { COMMENT_PRIORITY_MAX, COMMENT_PRIORITY_MIN } from './settings-devices-predefined-comments-form.constants';

export const validateCommentPriority = (order: number | null | undefined): PocInputValidity => {
    if (order == null) {
        return { state: 'error', type: ['value-missing'] };
    }
    if (order < COMMENT_PRIORITY_MIN) {
        return { state: 'error', type: ['range-underflow'] };
    }
    if (order > COMMENT_PRIORITY_MAX) {
        return { state: 'error', type: ['range-overflow'] };
    }
    return { state: 'valid' };
};

export const isCommentPriorityValid = (order: number | null | undefined): boolean =>
    validateCommentPriority(order).state === 'valid';

export const getCommentPriorityValidationMessages = (t: TFunction): ExtendedValidationMessages => {
    const outOfRange = t('settings.devices.predefined-comments.form.errors.comment-priority.out-of-range', {
        min: COMMENT_PRIORITY_MIN,
        max: COMMENT_PRIORITY_MAX,
    });
    return {
        error: {
            'value-missing': t('settings.devices.predefined-comments.form.errors.comment-priority.value-missing'),
            'range-underflow': outOfRange,
            'range-overflow': outOfRange,
        },
    };
};
